import hashString from '../../../utils/hashString.js';

/**
 * Generate a non-secure hash code from a set of grid templates.
 *
 * Used to generate a unique classname for each grid.
 *
 * Basically: concatenate all the keys and values and hash the resulting string.
 */

function hashTemplates(templates) {
  var strs = '';

  for (var breakpointName in templates) {
    strs += breakpointName + templates[breakpointName];
  }

  return hashString(strs);
}

export default hashTemplates;
//# sourceMappingURL=hashTemplates.js.map
